export const themeColors = [
  {
    key: 'pink',
    pickerBtnColor: '#f53893',
  },
  {
    key: 'green',
    pickerBtnColor: '#cbf3bd',
  },
];
